import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import { CLASSES } from '../../../assets/styles/styles'
import DocumentCard from '../../../components/common/DocumentCard'
import ZoomView from '../../../components/common/ZoomView'

function LegalDocuments({ data = [] }) {
  const [state, setState] = React.useState({
    show_modal: false,
    title: null,
    modal_images: null,
  })
  const handleState = (document) =>
    setState((pv) => ({
      ...pv,
      modal_images: document.file_path,
      title: document.title,
      show_modal: !pv.show_modal,
    }))

    
  return (
    <>
      <Container id='documents' className='my-5'>
        <Row className={CLASSES.content_center}>
          <h4 className='text-center mb-5'>Legal Documents</h4>
          {data.map((document, i) => (
            <Col key={document.id} lg={3} md={4} sm={6} className='mb-3'>
              <DocumentCard
                document={document}
                onClick={() => handleState(document)}
              />
            </Col>
          ))}
        </Row>
      </Container>
      <ZoomView state={state} handleState={() => handleState({})} />
    </>
  )
}

export default LegalDocuments
